var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative","height":"100%","width":"100%"}},[_c('LineChart',{attrs:{"data":_vm.chartData,"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }